/** Registered business details (GST REG-06 — M S Publications) */
export const BUSINESS = {
  legalName: 'M S Publications',
  tradeName: 'M S Publications',
  gstin: '37ACCFM0063B1ZS',
  constitution: 'Partnership',
  email: 'contact@repatikosam.com',
  phone: '9090448890',
  phoneCountryCode: '91',
  website: 'https://repatikosam.com',
  addressLabel: 'Administrative office',
  addressLine1: 'Door No. 5-82-25, 4th Lane',
  addressLine2: 'Pandaripuram',
  city: 'Guntur',
  state: 'Andhra Pradesh',
  stateCode: '37',
  pin: '522006',
  country: 'India',
  sac: '998431',
  sacLabel: 'Online text-based information / digital newspaper subscription',
  bank: {
    accountName: 'MS PUBLICATIONS',
    bankName: 'HDFC BANK',
    branch: 'BANJARA HILLS, TELANGANA',
    accountNumber: '99939000000733',
    ifsc: 'HDFC0000521',
  },
};

export function businessPhoneE164() {
  const digits = BUSINESS.phone.replace(/\D/g, '');
  return `${BUSINESS.phoneCountryCode}${digits}`;
}

export function businessPhoneDisplay() {
  const d = BUSINESS.phone.replace(/\D/g, '');
  return `+${BUSINESS.phoneCountryCode} ${d.slice(0, 5)} ${d.slice(5)}`;
}

export function businessTelHref() {
  return `tel:+${businessPhoneE164()}`;
}

export function businessWhatsAppHref(text = '') {
  const base = `https://wa.me/${businessPhoneE164()}`;
  if (!text) return base;
  return `${base}?text=${encodeURIComponent(text)}`;
}

export function businessAddressBlock() {
  const b = BUSINESS;
  const lines = `${b.addressLine1}, ${b.addressLine2}, ${b.city}, ${b.state} ${b.pin}, ${b.country}`;
  return b.addressLabel ? `${b.addressLabel}: ${lines}` : lines;
}

/** Leadership — About Us / footer */
export const LEADERSHIP_TEAM = [
  {
    id: 'srikanth',
    name: 'Srikanth Mikkilineni',
    roleKey: 'roleManagingDirector',
    image: '/srikanth-m.jpeg',
  },
  {
    id: 'srinivas',
    name: 'Dr. Sakhamuru Srinivas Prasad',
    roleKey: 'roleChiefEditor',
    image: '/srinivas.jpeg',
  },
];

export const SOCIAL = {
  youtube: 'https://www.youtube.com/@Repatikosam',
  facebook: 'https://www.facebook.com/profile.php?id=61590315428806',
  instagram: 'https://www.instagram.com/repatikosam_epaper/',
};

/** Native apps — set URLs when live on Play Store / App Store */
export const MOBILE_APP = {
  comingSoon: true,
  playStoreUrl: '',
  appStoreUrl: '',
};
